export const getLastSegmentOfPath = (thePath: string) =>
  thePath.substring(thePath.lastIndexOf('/') + 1);
